import React from 'react';

function MarkerPinIcon01({ fill, ...restProps }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={fill ?? ''}
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      <path
        d='M11.34 1.024c-1.314.136-2.249.391-3.28.894A8.874 8.874 0 0 0 3.939 6.02c-1.053 2.124-1.221 4.541-.467 6.74.662 1.931 1.822 3.696 3.967 6.039.809.884 3.894 3.964 4.081 4.075.152.089.227.106.48.106s.328-.017.48-.106c.187-.111 3.275-3.193 4.081-4.075 2.146-2.345 3.305-4.11 3.967-6.039a8.781 8.781 0 0 0-.444-6.7 8.996 8.996 0 0 0-6.764-4.959c-.409-.062-1.658-.11-1.98-.077m1.762 2.074c2.479.375 4.613 2.139 5.471 4.522.296.822.404 1.466.401 2.4-.004 1.142-.244 2.075-.844 3.28-.829 1.666-1.985 3.106-4.638 5.78l-1.488 1.5-1.086-1.08c-2.887-2.872-4.171-4.447-5.035-6.175-.617-1.234-.854-2.155-.857-3.325-.002-.703.044-1.106.198-1.725.547-2.214 2.228-4.068 4.396-4.848.63-.227 1.095-.325 1.92-.404.273-.026 1.186.018 1.562.075m-1.744 2.963c-1.128.176-2.215.913-2.789 1.892a3.992 3.992 0 0 0 1.943 5.751 3.988 3.988 0 0 0 5.192-2.216 3.963 3.963 0 0 0 .001-2.972 3.978 3.978 0 0 0-3.1-2.458 3.728 3.728 0 0 0-1.247.003m1.165 2.012a2.011 2.011 0 0 1 1.444 1.617c.1.653-.094 1.243-.564 1.714-.401.403-.856.596-1.403.596-.515 0-.962-.178-1.347-.535-1.33-1.236-.464-3.46 1.347-3.46.143 0 .378.031.523.068'
        fill-rule='evenodd'
        fill={fill ?? ''}
      />
    </svg>
  );
}

export default MarkerPinIcon01;
